var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cross-sell-cont"},[_c('crosssell',{attrs:{"products":_vm.products,"product-page-mode":"","title":"You might also like..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }